<template>
    <noscript><img :src="url" style="position:fixed; left:-999px;" alt=""/></noscript>
</template>

<script>
    import { bus } from '../../main'

    export default {
        name: 'Vk',
        data() {
            return {
                loaded: false
            }
        },
        methods: {},
        components: {},
        computed: {
            id: function () {
                return process.env.VUE_APP_VK;
            },
            url: function () {
                return 'https://vk.com/rtrg?p=' + this.id;
            },
            debug: function () {
                return process.env.VUE_APP_VK_DEBUG !== 'false';
            }
        },
        mounted() {
            const self = this;

            !function () {
                const t = document.createElement("script");
                t.type = "text/javascript", t.async = !0, t.src = "https://vk.com/js/api/openapi.js?168", t.onload = function () {
                    window.VK.Retargeting.Init(self.id), window.VK.Retargeting.Hit();
                    self.$store.commit('setAnalyticsLoaded', 'vk');
                    self.loaded = true;
                }, document.head.appendChild(t);

                setTimeout(function() {
                    if (!self.loaded) {
                        self.$store.commit('setAnalyticsLoaded', 'vk');
                    }
                }, 1500);
            }();

            bus.$on('laboratoryLanding.analytics', (data) => {
                if (!self.loaded) {
                    return;
                }

                let action;
                switch (data.action) {
                    case '20sec':
                        action = 'view_content';
                        break;
                    case 'loadAttachments':
                        action = 'initiate_checkout';
                        break;
                }

                if (!action) {
                    return;
                }

                if (!self.debug) {
                    window.VK.Goal(action);
                }

                console.debug('vk send event:', action, self.debug);
            });
        },
    }
</script>